import { useState, useEffect, useRef } from 'react';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { confirmDialog } from '../../shared/ConfirmModal';
import { Toast } from 'primereact/toast';
import { ToggleButton } from 'primereact/togglebutton';
import { getGhlUsers, deleteLeader, leaderLocations, leaderLocationManage, passwordUpdate, updateUserDesignation, updateUserCompany, getSoftwareUsers, convertToUser, convertToLeader, terminateSoftwareUser, updateOfficeEmailPassword, leaderTeams, leaderTeamManage, updateFlyer, updateActivePipelineAccount, changeUserStatus, updateApplicationPipeline, get_form_initials, updateAppFollowers, userUpdate, updateUserLanguages, baseUrl, toggleUserLockout, toggleKpiManaged, updateUserName } from '../../utils/urls';
import axios from '../../utils/axios';
import { useNavigate } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { MultiSelect } from 'primereact/multiselect';
import AppModal from '../../shared/AppModal';
import { FileUpload } from 'primereact/fileupload';
import { Avatar } from 'primereact/avatar';
import { Dropdown } from 'primereact/dropdown';
import FlexComponent from '../FlexComponent';
import { useSelector } from 'react-redux';
import './OnboardedUsersTable.css';

export default function OnboardedUsersTable({ designationList, companiesList, branchesList }) {
    const navigate = useNavigate();
    const toast = useRef(null);
    const [customers, setCustomers] = useState(null);
    const [fullCustomersData, setFullCustomersData] = useState([])
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        full_name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
        username: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
    });

    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false)
    const [isMounted, setIsMounted] = useState(false);
    const [locationVisible, setLocationVisible] = useState(false);
    const [activePipelineVisible, setActivePipelineVisible] = useState(false);
    const [selectedActivePipeline, setSelectedActivePipeline] = useState("")
    const [selectedApplicationPipeline, setSelectedApplicationPipeline] = useState("")
    const [selectedDefaultFollowers, setSelectedDefaultFollowers] = useState([])
    const [defaultLanguage, setDefaultLanguage] = useState("")
    const [selectedActivePipelineUser, setSelectedActivePipelineUser] = useState("")
    const [locationData, setLocationData] = useState([]);

    const [allowedLocations, setAllowedLocations] = useState(null);
    const [activeLocations, setActiveLocations] = useState(null);
    const [manageLeaderId, setManageLeaderId] = useState(null);
    const [convertLeader, setConverLeader] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [userVisible, setUserVisible] = useState(false);
    const [password, setPassword] = useState('');
    const [selectedPasswordUser, setSelectedPasswordUser] = useState(null);
    const [emailPassword360Visible, setEmailPassword360Visible] = useState(false);
    const [email360, setEmail360] = useState('');
    const [businessPhone, setBusinessPhone] = useState('');
    const [officeTitle, setOfficeTitle] = useState('');
    const [selectedEmailPassword360User, setSelectedEmailPassword360User] = useState(null);
    const [designationDialogVisible, setDesignationDialogVisible] = useState(false);
    const [selectedDesignationUser, setSelectedDesignationUser] = useState(null);
    const [selectedDesignation, setSelectedDesignation] = useState(null);
    const [selectedSubDesignation, setSelectedSubDesignation] = useState(null);
    const [branchDialogVisible, setBranchDialogVisible] = useState(false);
    const [selectedBranchUser, setSelectedBranchUser] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);
    const [selectedCostCenter, setSelectedCostCenter] = useState(null);
    const [flyerDialogVisible, setFlyerDialogVisible] = useState(false);
    const [selectedFlyerUser, setSelectedFlyerUser] = useState(null);
    const [nmlsId, setNmlsId] = useState('');
    const [qrLink, setQrLink] = useState('');
    const dt = useRef(null);
    const isSuperuser = useSelector((state) => state.user.isSuperuser);
    const [userOptions, setUserOptions] = useState([]);
    const [appStatus, setAppStatus] = useState("")
    const [nameDialogVisible, setNameDialogVisible] = useState(false);
    const [selectedNameUser, setSelectedNameUser] = useState(null);
    const [editFirstName, setEditFirstName] = useState('');
    const [editLastName, setEditLastName] = useState('');

    useEffect(() => {
        getAllSoftwareUsers();
    }, [getSoftwareUsers, isMounted]);

    useEffect(() => {
        // console.log("selectedActivePipeline", selectedActivePipeline)
        if (!selectedActivePipeline) {
            setSelectedApplicationPipeline("")
        }
        const selectedLocation = selectedActivePipeline;
        const selectedLocationData = locationData?.find((location) => location.location_id === selectedLocation);

        const options = selectedLocationData?.users?.map((user) => ({
            label: user.full_name || user.name,
            value: user.user_id,
        })) || [];
        setUserOptions(options);
    }, [locationData, selectedActivePipeline]);

    useEffect(() => {
        if (appStatus) {
            let updatedData = fullCustomersData.filter((data) => data.status === appStatus)
            setCustomers(updatedData)
        } else {
            setCustomers(fullCustomersData)
        }
    }, [appStatus])

    const getAllSoftwareUsers = () => {
        axios.get(getSoftwareUsers, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setCustomers(response.data);
                    setFullCustomersData(response.data)
                    if (appStatus) {
                        let updatedData = response.data.filter((data) => data.status === appStatus)
                        setCustomers(updatedData)
                    }
                    setLoading(false);
                }
            })
            .catch(() => {
                setCustomers(null);
            });
    };

    const getLocationList = async (userId) => {
        if (userId) {
            try {
                const response = await axios.get(`${get_form_initials}?userId=${userId}`, {
                    headers: { 'Content-Type': 'application/json' },
                });
                if (response.status === 200) {
                    const data = response.data;
                    const mergedData = [
                        // data.default,
                        ...data.location_user_data
                    ];
                    // console.log(mergedData);
                    setLocationData(mergedData);
                    const selectedLocation = selectedActivePipeline;
                    const selectedLocationData = data.location_user_data?.find((location) => location.location_id === selectedLocation);

                    const options = selectedLocationData?.users?.map((user) => ({
                        label: user.full_name || user.name,
                        value: user.user_id,
                    })) || [];
                    setUserOptions(options);
                }
            } catch (error) {
                // Handle errors here
                console.error('Error fetching location list:', error);
            }
        }
    };

    const onGlobalFilterChange = (event) => {
        const value = event.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
    };

    const getSeverity = (value) => {
        switch (value) {
            case true:
                return 'success';
            case false:
                return 'danger';
            default:
                return null;
        }
    };

    const manageLocationView = (rowData) => {
        const leader_id = rowData.id;
        return (
            <div>
                {rowData.user_type === "Team Leader" ?
                    <Button className='view-button' label="Manage" icon="pi pi-external-link" onClick={() => manageTeamDialog(leader_id)} />
                    : <Button className='view-button' label="Manage" icon="pi pi-external-link" onClick={() => manageLocationDialog(leader_id)} />
                }
            </div>
        );
    };

    // const manageActivePipelineView = (rowData) => {
    //     const leader_id = rowData.id;
    //     const activePipelineId = rowData.active_pipeline_id || true

    //     return (
    //         <div>
    //             {rowData.user_type === "Team Leader" ?
    //                 <Button className='view-button' style={{width: "100%", textAlign:"center", background : rowData.active_pipeline_name && "transparent", color : rowData.active_pipeline_name && "black", borderColor: rowData.active_pipeline_name && "black" }}  label={rowData.active_pipeline_name || "Add Active Pipeline"}  onClick={() => manageTeamDialog(leader_id, false,  activePipelineId)} />
    //                 : <Button className='view-button' style={{width: "100%", textAlign:"center", background : rowData.active_pipeline_name && "transparent", color : rowData.active_pipeline_name && "black", borderColor: rowData.active_pipeline_name && "black" }}  label={rowData.active_pipeline_name || "Add Active Pipeline"} onClick={() => manageLocationDialog(leader_id, false, activePipelineId)} />
    //             }
    //         </div>
    //     );
    // };

    const manageUserTypes = (rowData) => {
        const user_id = rowData.id;
        return (
            <div>
                {rowData.user_type === "User" ?
                    <Button className='view-button' label="Convert To Leader" onClick={() => manageTeamDialog(user_id, true)} /> :
                    <Button className='view-button' label="Convert To User" onClick={() => convertUserLeader(rowData.user_type, user_id)} />
                }
            </div>
        );
    };

    const convertUserLeader = (userType, userId) => {
        confirmDialog({
            message: userType === "User" ? 'Are you sure you want to Convert this User To Team Leader' : "Are you sure you want to Convert this Team Leader To User",
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                setIsMounted(true);
                let Url = userType === "User" ? `${convertToLeader}${userId}` : `${convertToUser}${userId}`;
                axios.post(Url, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            setIsMounted(false);
                            toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                        } else {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                            setIsMounted(false);
                        }
                    })
                    .catch(() => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                        setIsMounted(false);
                    });
            },
            reject: () => {
                console.log("closed");
            }
        });
    };

    const designationView = (rowData) => {
        const userId = rowData.id;
        return (
            <Button
                className='view-button'
                label="Manage"
                icon="pi pi-pencil"
                onClick={() => {
                    setSelectedDesignationUser(userId);
                    setSelectedDesignation(getIdByName(rowData.designation));
                    setSelectedSubDesignation(getSubDesignationIdByTitle(rowData.sub_designation, rowData.designation));
                    setDesignationDialogVisible(true);
                }}
            />
        );
    };

    const activePipelineView = (rowData) => {
        const userId = rowData.id;
        const activePipelineId = rowData.active_pipeline_id || true

        return (
            <Button
                className='view-button'
                label="Manage Active Pipeline"
                // icon="pi pi-pencil"
                onClick={() => {
                    setSelectedActivePipelineUser(userId);
                    setSelectedActivePipeline(rowData.active_pipeline_id);
                    setSelectedApplicationPipeline(rowData.app_pipeline_id);
                    setSelectedDefaultFollowers(rowData.app_default_followers)
                    getLocationList(userId)
                    if (rowData.user_type === "Team Leader") {
                        manageTeamDialog(userId, false, activePipelineId)
                    } else {
                        manageLocationDialog(userId, false, activePipelineId)
                    }
                    // setActivePipelineVisible(true);
                }}
            />
        );
    };

    const branchView = (rowData) => {
        const userId = rowData.id;
        return (
            <Button
                className='view-button'
                label="Manage"
                icon="pi pi-pencil"
                onClick={() => {
                    setSelectedBranchUser(userId);
                    setSelectedBranch(getBranchIdByName(rowData.branch));
                    setSelectedCostCenter(getCostCenterIdByName(rowData.cost_center, rowData.branch));
                    setBranchDialogVisible(true);
                }}
            />
        );
    };

    const nmlsIdQRLinkView = (rowData) => {
        const userId = rowData.id;
        return (
            <div className="flex align-items-center gap-2">
                {/* <span>{rowData.nmls_id || 'N/A'}</span> */}
                <Button
                    label='NMLS & QR'
                    style={{ background: "#0f173e" }}
                    icon="pi pi-pencil"
                    // className="p-button-text" 
                    onClick={() => {
                        setSelectedFlyerUser(userId);
                        setNmlsId(rowData.nmls_id || '');
                        setQrLink(rowData.qr_link || '');
                        setFlyerDialogVisible(true);
                    }}
                />
            </div>
        );
    };


    function getIdByName(name) {
        const item = designationList.find(obj => obj.title === name);
        return item ? item.id : null;
    }

    function getSubDesignationIdByTitle(subDesignationTitle, designationTitle) {
        const designation = designationList.find(obj => obj.title === designationTitle);
        if (designation && designation.subdesignations) {
            const subDesignation = designation.subdesignations.find(sub => sub.title === subDesignationTitle);
            return subDesignation ? subDesignation.id : null;
        }
        return null;
    }

    function getBranchIdByName(name) {
        const item = branchesList.find(obj => obj.name === name);
        return item ? item.id : null;
    }

    function getCostCenterIdByName(costCenterName, branchName) {
        const branch = branchesList.find(obj => obj.name === branchName);
        if (branch && branch.cost_centers) {
            const costCenter = branch.cost_centers.find(cc => cc.name === costCenterName);
            return costCenter ? costCenter.id : null;
        }
        return null;
    }

    function getIdByCompanyName(name) {
        const item = companiesList.find(obj => obj.title === name);
        return item ? item.id : null;
    }

    const companyView = (rowData) => {
        const userId = rowData.id;
        const company = rowData.company;
        return (
            <div>
                <Dropdown
                    id="companyId"
                    value={getIdByCompanyName(company)}
                    options={companiesList.map(company => ({
                        label: company.title,
                        value: company.id,
                    })) || []}
                    style={{ width: '100%' }}
                    onChange={(e) => handleAddCompany(e.value, userId)}
                    placeholder="Select Company"
                />
            </div>
        );
    };

    const languageView = (rowData) => {
        const userId = rowData.id;
        const languageData = rowData.languages || [];
        let language = ""
        let isboth = languageData?.some(lang => lang.name === "English") && languageData.some(lang => lang.name === "Spanish");
        if (isboth) {
            language = "Spanish & Some English"
        } else {
            language = languageData[0]?.name
        }

        return (
            <div>
                <Dropdown
                    id="language"
                    value={language}
                    options={[
                        { label: 'English', value: 'English', },
                        { label: 'Spanish', value: 'Spanish' },
                        { label: 'Spanish & Some English', value: 'Spanish & Some English' },
                        // { label: 'Other', value: 'Other' },
                    ]}
                    style={{ width: '100%' }}
                    onChange={(e) => handleAddLanguage(e.value, userId)}
                    placeholder="Select Language"
                />
            </div>
        );
    };

    const userStatusView = (rowData) => {
        const userId = rowData.id;
        const userStatus = rowData.status;
        return (
            <div>
                <Dropdown
                    id="userStatus"
                    value={userStatus}
                    options={[
                        { label: "Active", value: "Active" },
                        { label: "Inactive", value: "Inactive" },
                        { label: "Terminated", value: "Terminated" }
                    ]}
                    style={{ width: '100%' }}
                    onChange={(e) => handleUserStatus(e.value, userId)}
                    placeholder="Select Status"
                />
            </div>
        );
    };

    const handleUserStatus = (status, userId) => {
        setIsMounted(true);
        const data = { status: status };
        const url = `${changeUserStatus}${userId}`;
        axios.post(url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                    setIsMounted(false);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    setIsMounted(false);
                }
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setIsMounted(false);
            });
    };

    // console.log(activeLocations);


    const manageLocationDialog = (leader_id, userType = false, activePipelineId = "") => {
        const manageLocationUrl = `${leaderLocations}${leader_id}`;
        axios.get(manageLocationUrl, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setActiveLocations(response.data.all_active_locations);
                    setAllowedLocations(response.data.allowed_locations);
                    setManageLeaderId(leader_id);
                    if (!activePipelineId) {
                        setLocationVisible(true);
                    } else {
                        setActivePipelineVisible(true);
                        // setSelectedActivePipeline(activePipelineId)
                    }
                }
            })
            .catch(() => {
                setActiveLocations(null);
                setAllowedLocations(null);
                setManageLeaderId(null);
                setLocationVisible(false);
                setActivePipelineVisible(false)
                setSelectedActivePipeline("")
            });
    };

    const manageTeamDialog = (leader_id, convert = false, activePipelineId = "") => {
        const manageLocationUrl = `${leaderTeams}${leader_id}`;
        axios.get(manageLocationUrl, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setActiveLocations(response.data.all_active_teams);
                    setAllowedLocations(response.data.allowed_teams);
                    setManageLeaderId(leader_id);
                    setConverLeader(convert);
                    if (!activePipelineId) {
                        setLocationVisible(true);
                    } else {
                        setActivePipelineVisible(true);
                        // setSelectedActivePipeline(activePipelineId)
                    }
                }
            })
            .catch(() => {
                setActiveLocations(null);
                setAllowedLocations(null);
                setManageLeaderId(null);
                setConverLeader(false);
                setLocationVisible(false);
                setActivePipelineVisible(false)
                setSelectedActivePipeline("")
            });
    };

    const accept = (Data) => {
        axios.post(deleteLeader, Data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsMounted(!isMounted);
                    toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            });
    };

    const reject = () => {
        console.log('closed');
    };

    const deleteBody = (rowData) => {
        const leader_id = rowData.id;
        return <Button icon="pi pi-trash" severity="danger" aria-label="Delete" onClick={() => handleDeleteLeader(leader_id)} />;
    };

    const terminateBody = (rowData) => {
        const user_id = rowData.id;
        return (
            <div>
                {rowData.is_terminated ?
                    <Button className='view-button' label="Terminated" onClick={() => TerminateUser(rowData.is_terminated, user_id)} /> :
                    <Button style={{ background: "green" }} className='view-button' label="Active" onClick={() => TerminateUser(rowData.is_terminated, user_id)} />
                }
            </div>
        );
    };

    const TerminateUser = (isActive, userId) => {
        confirmDialog({
            message: isActive ? "Are you sure you want to Activate this User" : 'Are you sure you want to Terminate this User',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                let Url = `${terminateSoftwareUser}${userId}`;
                setIsMounted(true);
                const data = {
                    status: String(!isActive)
                };
                axios.post(Url, data, {
                    headers: { 'Content-Type': 'application/json' }
                })
                    .then((response) => {
                        if (response.status === 200) {
                            setIsMounted(false);
                            toast.current.show({ severity: 'success', summary: 'User Terminated Successfully', detail: '', life: 3000 });
                        } else {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                            setIsMounted(false);
                        }
                    })
                    .catch(() => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                        setIsMounted(false);
                    });
            },
            reject: () => {
                console.log("closed");
            }
        });
    };

    const onUpload = () => {
        setIsMounted(!isMounted);
        toast.current.show({ severity: 'info', summary: 'Success', detail: 'Profile image updated' });
    };

    const uploadBody = (rowData) => {
        const leader_id = rowData.id;
        return (
            <FileUpload
                mode="basic"
                name="image"
                url={`${baseUrl}/api/upload/${leader_id}`}
                accept="image/*"
                maxFileSize={10485760}
                onUpload={onUpload}
                auto
                chooseLabel="Upload"
            />
        );
    };

    const bizCardUploadBody = (rowData) => {
        const leader_id = rowData.id;
        const ghl_user_id = rowData.ghl_user_id
        // console.log("rowData---", rowData);
        
        return (
            <FileUpload
                mode="basic"
                name="biz_card"
                url={`${baseUrl}/api/business_card_upload/${ghl_user_id}`}
                accept="image/*"
                maxFileSize={10485760}
                onBeforeSend={(e) => {
                    const tokens = JSON.parse(localStorage.getItem('authTokens'));
                    if (tokens?.access) {
                        e.xhr.setRequestHeader('Authorization', `Bearer ${tokens.access}`);
                    }
                }}
                onUpload={() => {
                    setIsMounted(!isMounted);
                    toast.current.show({ severity: 'info', summary: 'Success', detail: 'Business card updated' });
                }}
                auto
                chooseLabel="Upload"
            />
        );
    };

    const handlePasswordOn = (user_id) => {
        setUserVisible(true);
        setSelectedPasswordUser(user_id);
    };

    const handleNameOn = (rowData) => {
        setSelectedNameUser(rowData.id);
        setEditFirstName(rowData.first_name || '');
        setEditLastName(rowData.last_name || '');
        setNameDialogVisible(true);
    };

    const handleNameOnHide = () => {
        setNameDialogVisible(false);
        setSelectedNameUser(null);
        setEditFirstName('');
        setEditLastName('');
    };

    const handleNameSubmit = () => {
        if (!editFirstName.trim()) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please enter first name', life: 2000 });
            return;
        }
        setSubmitLoading(true);
        axios.post(`${updateUserName}${selectedNameUser}`, { first_name: editFirstName.trim(), last_name: editLastName.trim() }, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setIsMounted(!isMounted);
                    handleNameOnHide();
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Name updated successfully', life: 3000 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
                setSubmitLoading(false);
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setSubmitLoading(false);
            });
    };

    const handlePasswordOnHide = () => {
        setUserVisible(false);
        setSelectedPasswordUser(null);
        setPassword('');
    };

    const handleEmailPassword360On = (rowData) => {
        setEmailPassword360Visible(true);
        setSelectedEmailPassword360User(rowData.id);
        setEmail360(rowData.office_360_email);
        setBusinessPhone(rowData.business_phone || '');
        setOfficeTitle(rowData.title);
    };

    const handleEmailPassword360OnHide = () => {
        setEmailPassword360Visible(false);
        setSelectedEmailPassword360User(null);
        setOfficeTitle('');
        setEmail360('');
        setBusinessPhone('');
    };

    const updatePasswordBody = (rowData) => {
        const leader_id = rowData.id;
        return <Button className='view-button' label="" icon="pi pi-user-edit" onClick={() => handlePasswordOn(leader_id)} />;
    };

    const update360EmailPassword = (rowData) => {
        const leader_id = rowData.id;
        return <Button className='view-button' label="Business Info" icon="pi pi-user-edit" onClick={() => handleEmailPassword360On(rowData)} />;
    };

    const handlePasswordVisible = () => {
        setPasswordVisible(!passwordVisible);
    };


    function isPasswordValid(password) {
        const uppercaseRegex = /[A-Z]/;
        const lowercaseRegex = /[a-z]/;
        const digitRegex = /\d/;
        const specialCharRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/;
        const isLengthValid = password.length >= 8;
        const hasUppercase = uppercaseRegex.test(password);
        const hasLowercase = lowercaseRegex.test(password);
        const hasDigit = digitRegex.test(password);
        const hasSpecialChar = specialCharRegex.test(password);
        return isLengthValid && hasUppercase && hasLowercase && hasDigit && hasSpecialChar;
    }

    const handlePasswordSubmit = () => {
        const trimmedPassword = password ? password?.trim() : null;
        if (trimmedPassword == null || trimmedPassword === '') {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please enter the password', life: 2000 });
        } else {
            const isValid = isPasswordValid(password);
            if (isValid) {
                const data = { password };
                setSubmitLoading(true)
                axios.post(`${passwordUpdate}${selectedPasswordUser}`, data, {
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((response) => {
                        if (response.status === 200) {
                            setIsMounted(!isMounted);
                            setUserVisible(false);
                            setSelectedPasswordUser(null);
                            setPassword('');
                            toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                        } else {
                            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                        }
                        setSubmitLoading(false)
                    })
                    .catch(() => {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                        setSubmitLoading(false)
                    });
            } else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'The password must be more than 8 characters including uppercase, lowercase, numbers and special characters', life: 3000 });
            }
        }
    };

    const isValidEmail = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };

    const isValidUrl = (url) => {
        const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/;
        return urlRegex.test(url);
    };

    const handleEmailPassword360Submit = () => {
        // if (!email360?.trim()) {
        //     toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please enter the Email', life: 2000 });
        // } else {
        const isValid = isValidEmail(email360);
        if (!email360 || (email360 && isValid)) {
            const data = {
                title: officeTitle,
                email: email360,
                business_phone: businessPhone,
            };
            setSubmitLoading(true)
            axios.post(`${updateOfficeEmailPassword}${selectedEmailPassword360User}`, data, {
                headers: { 'Content-Type': 'application/json' },
            })
                .then((response) => {
                    if (response.status === 200) {
                        setIsMounted(!isMounted);
                        setEmailPassword360Visible(false);
                        setSelectedEmailPassword360User(null);
                        setOfficeTitle('');
                        setEmail360('');
                        setBusinessPhone('');
                        toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                    } else {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    }
                    setSubmitLoading(false)
                })
                .catch(() => {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    setSubmitLoading(false)
                });
        } else {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please Enter Valid Email', life: 3000 });
        }
        // }
    };

    const handleDesignationSubmit = () => {
        if (!selectedDesignation || !selectedSubDesignation) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please select both designation and sub designation', life: 2000 });
            return;
        }
        setIsMounted(true);
        const data = {
            designation_id: selectedDesignation,
            sub_designation_id: selectedSubDesignation || null
        };
        const url = `${updateUserDesignation}${selectedDesignationUser}`;
        axios.post(url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Designation updated successfully', life: 3000 });
                    setIsMounted(false);
                    setDesignationDialogVisible(false);
                    setSelectedDesignationUser(null);
                    setSelectedDesignation(null);
                    setSelectedSubDesignation(null);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    setIsMounted(false);
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setIsMounted(false);
            });
    };

    const handleActiveAndApplicationPipelineSubmit = () => {
        if (!selectedActivePipeline) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please select both designation and sub designation', life: 2000 });
            return;
        }
        // setIsMounted(true);
        if (selectedApplicationPipeline) {
            handleAddActivePipelineLocation(selectedActivePipeline, selectedActivePipelineUser)
        }
        // if (selectedDefaultFollowers && selectedDefaultFollowers?.length > 0) {
        handleAddFollowers(selectedActivePipelineUser)
        // }
        const data = {
            pipeline_user: selectedApplicationPipeline
        };
        const url = `${updateApplicationPipeline}${selectedActivePipelineUser}/`;
        axios.post(url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'updated successfully', life: 3000 });
                    setIsMounted(false);
                    setActivePipelineVisible(false);
                    setSelectedActivePipelineUser(null);
                    setSelectedActivePipeline(null);
                    setSelectedApplicationPipeline(null);
                    setSelectedDefaultFollowers([])
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    setIsMounted(false);
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setIsMounted(false);
            });
    };

    const handleBranchSubmit = () => {
        if (!selectedBranch || !selectedCostCenter) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please select both a branch and a cost center', life: 2000 });
            return;
        }
        setIsMounted(true);
        const data = {
            branch_id: selectedBranch,
            cost_center_id: selectedCostCenter
        };
        const url = `${updateFlyer}${selectedBranchUser}/`;
        axios.patch(url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Branch updated successfully', life: 3000 });
                    setIsMounted(false);
                    setBranchDialogVisible(false);
                    setSelectedBranchUser(null);
                    setSelectedBranch(null);
                    setSelectedCostCenter(null);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    setIsMounted(false);
                }
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setIsMounted(false);
            });
    };

    const handleFlyerSubmit = () => {
        if (qrLink && !isValidUrl(qrLink)) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please enter a valid QR Link URL', life: 2000 });
            return;
        }
        setIsMounted(true);
        const data = {
            nmls_id: nmlsId || null,
            qr_link: qrLink || null
        };
        setSubmitLoading(true)
        const url = `${updateFlyer}${selectedFlyerUser}/`;
        axios.patch(url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: 'Flyer data updated successfully', life: 3000 });
                    setIsMounted(false);
                    setFlyerDialogVisible(false);
                    setSelectedFlyerUser(null);
                    setNmlsId('');
                    setQrLink('');
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    setIsMounted(false);
                }
                setSubmitLoading(false)
            })
            .catch((error) => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setIsMounted(false);
                setSubmitLoading(false)
            });
    };

    const flyerManageFooter = (
        <div>
            <Button
                className='view-button'
                label="Submit"
                icon="pi pi-check"
                loading={submitLoading}
                onClick={handleFlyerSubmit}
                autoFocus
            />
            <Button
                className='view-button'
                label="Cancel"
                icon="pi pi-times"
                onClick={() => {
                    setFlyerDialogVisible(false);
                    setSelectedFlyerUser(null);
                    setNmlsId('');
                    setQrLink('');
                }}
                style={{ background: "white", color: "black", marginLeft: '1rem' }}
            />
        </div>
    );

    const userManageFooter = (
        <div>
            <Button className='view-button' label="Submit" icon="pi pi-check" loading={submitLoading} onClick={handlePasswordSubmit} autoFocus />
        </div>
    );

    const nameManageFooter = (
        <div>
            <Button className='view-button' label="Submit" icon="pi pi-check" loading={submitLoading} onClick={handleNameSubmit} autoFocus />
        </div>
    );

    const emailPassword360Footer = (
        <div>
            <Button className='view-button' label="Submit" icon="pi pi-check" loading={submitLoading} onClick={handleEmailPassword360Submit} autoFocus />
        </div>
    );

    const designationManageFooter = (
        <div>
            <Button
                className='view-button'
                label="Submit"
                icon="pi pi-check"
                onClick={handleDesignationSubmit}
                disabled={!selectedDesignation || !selectedSubDesignation}
                autoFocus
            />
            <Button
                className='view-button'
                label="Cancel"
                icon="pi pi-times"
                onClick={() => {
                    setDesignationDialogVisible(false);
                    setSelectedDesignationUser(null);
                    setSelectedDesignation(null);
                    setSelectedSubDesignation(null);
                }}
                style={{ background: "white", color: "black", marginLeft: '1rem' }}
            />
        </div>
    );

    const manageActivePipelineFooter = (
        <div>
            <Button
                className='view-button'
                label="Submit"
                icon="pi pi-check"
                onClick={handleActiveAndApplicationPipelineSubmit}
                disabled={!selectedActivePipeline}
                autoFocus
            />
            <Button
                className='view-button'
                label="Cancel"
                icon="pi pi-times"
                onClick={() => {
                    setActivePipelineVisible(false);
                    setSelectedActivePipelineUser(null);
                    setSelectedActivePipeline(null);
                    setSelectedApplicationPipeline(null);
                    setSelectedDefaultFollowers([])
                }}
                style={{ background: "white", color: "black", marginLeft: '1rem' }}
            />
        </div>
    );

    const branchManageFooter = (
        <div>
            <Button
                className='view-button'
                label="Submit"
                icon="pi pi-check"
                onClick={handleBranchSubmit}
                disabled={!selectedBranch || !selectedCostCenter}
                autoFocus
            />
            <Button
                className='view-button'
                label="Cancel"
                icon="pi pi-times"
                onClick={() => {
                    setBranchDialogVisible(false);
                    setSelectedBranchUser(null);
                    setSelectedBranch(null);
                    setSelectedCostCenter(null);
                }}
                style={{ background: "white", color: "black", marginLeft: '1rem' }}
            />
        </div>
    );

    const handleDeleteLeader = (leader_id) => {
        const data = { leader_id };
        confirmDialog({
            message: 'Are you sure you want to delete this User?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => accept(data),
            reject
        });
    };

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    const renderHeader = () => {
        const value = filters['global'] ? filters['global'].value : '';
        return (
            <div className='header-container-with-csv-export'>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText type="search" value={value || ''} onChange={(e) => onGlobalFilterChange(e)} placeholder="Global Search" />
                </span>

                <Dropdown
                    id="appStatus"
                    value={appStatus}
                    options={[
                        { label: 'Active', value: 'Active' },
                        { label: 'Inactive', value: 'Inactive' },
                        { label: 'Terminated', value: 'Terminated' }
                    ]}
                    style={{ width: '200px' }}
                    onChange={(e) => {
                        setAppStatus(e.value)
                    }}
                    showClear={appStatus}
                    placeholder="Select Status"
                />

                {isSuperuser &&
                    <div className="flex align-items-center justify-content-end gap-2">
                        <Button type="button" icon="pi pi-file" rounded onClick={() => exportCSV(false)} data-pr-tooltip="CSV" />
                    </div>
                }
            </div>
        );
    };

    const srNoBodyTemplate = (rowData, props) => {
        const rowIndex = props.rowIndex + 1;
        return <div className='status'>{rowIndex}</div>;
    };

    const handleLocationOnHide = () => {
        setActiveLocations(null);
        setAllowedLocations(null);
        setManageLeaderId(null);
        setConverLeader(false);
        setLocationVisible(false);
        setActivePipelineVisible(false)
        setSelectedActivePipeline("")
        setSelectedApplicationPipeline("")
        setSelectedDefaultFollowers([])
    };

    const handleLocationSubmit = () => {
        let Url = convertLeader ? `${convertToLeader}${manageLeaderId}` : leaderLocationManage;
        let data = convertLeader ?
            { "allowedTeams": allowedLocations?.map((team) => team.team_id) } :
            { "leader_id": manageLeaderId, "allowed_locations": allowedLocations };

        axios.post(Url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    setActiveLocations(null);
                    setAllowedLocations(null);
                    setManageLeaderId(null);
                    setConverLeader(false);
                    setLocationVisible(false);
                    setActivePipelineVisible(false)
                    setIsMounted(!isMounted);
                    setSelectedActivePipeline("")
                    toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            });
    };

    const locationManageFooter = (
        <div>
            <Button className='view-button' disabled={(convertLeader && !allowedLocations.length ? true : false)} label="Submit" icon="pi pi-check" onClick={handleLocationSubmit} autoFocus />
        </div>
    );

    const activePipelineFooter = (
        <div>
            {/* <Button className='view-button' disabled={(convertLeader && !allowedLocations.length ? true : false)} label="Submit" icon="pi pi-check" onClick={handleLocationSubmit} autoFocus /> */}
            {/* <Button className='view-button' label="Close" onClick={()=> {
                setActivePipelineVisible(false)
            }} autoFocus /> */}
        </div>
    );

    const getInitials = (name) => {
        const words = name.split(' ');
        const firstInitial = words[0] ? words[0][0].toUpperCase() : '';
        const secondInitial = words[1] ? words[1][0].toUpperCase() : '';
        return firstInitial + secondInitial;
    };

    const userBodyTemplate = (rowData) => {
        const image_url = rowData.image;
        const initials = getInitials(rowData.full_name);
        return (
            <div className="flex align-items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                {image_url ?
                    <img src={image_url} width="32" /> :
                    <Avatar label={initials} style={{ backgroundColor: '#0f173e', color: '#ffffff' }} shape="circle" />
                }
                <span>{rowData.full_name}</span>
                <Button className='view-button' icon="pi pi-pencil" onClick={() => handleNameOn(rowData)} style={{ padding: '0.25rem' }} />
            </div>
        );
    };

    const handleAddDesignation = (designationId, subDesignationId, userId) => {
        setIsMounted(true);
        const data = {
            designation_id: designationId,
            sub_designation_id: subDesignationId
        };
        const url = `${updateUserDesignation}${userId}`;
        axios.post(url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                    setIsMounted(false);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    setIsMounted(false);
                }
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setIsMounted(false);
            });
    };

    const handleAddCompany = (companyId, userId) => {
        setIsMounted(true);
        const data = { company_id: companyId };
        const url = `${updateUserCompany}${userId}`;
        axios.post(url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                    setIsMounted(false);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    setIsMounted(false);
                }
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setIsMounted(false);
            });
    };

    const handleAddLanguage = (language, userId) => {
        setIsMounted(true);
        let data = {}
        if (language.includes("English") && language.includes("Spanish")) {
            data = { languages: ["English", "Spanish"] };
        } else {
            data = { languages: [language] };
        }
        const url = `${updateUserLanguages}${userId}/`;
        axios.post(url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                    setIsMounted(false);
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                    setIsMounted(false);
                }
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setIsMounted(false);
            });
    };

    const handleAddActivePipelineLocation = (locationId, userId) => {
        setIsMounted(true);
        setSelectedActivePipeline(locationId)
        const data = { location_id: locationId };
        const url = `${updateActivePipelineAccount}${userId}/`;
        // console.log(data, url);

        axios.post(url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                // if (response.status === 200) {
                //     toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                //     setIsMounted(false);
                // } else {
                //     toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                //     setIsMounted(false);
                // }
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setIsMounted(false);
            });
    };

    const handleAddFollowers = (userId) => {
        setIsMounted(true);
        // setSelectedActivePipeline(locationId)
        const data = { followers: selectedDefaultFollowers };
        const url = `${updateAppFollowers}${userId}/`;
        // console.log(data, url);

        axios.post(url, data, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                // if (response.status === 200) {
                //     toast.current.show({ severity: 'success', summary: 'Success', detail: '', life: 3000 });
                //     setIsMounted(false);
                // } else {
                //     toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                //     setIsMounted(false);
                // }
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                setIsMounted(false);
            });
    };

    const header = renderHeader();

    function parseDateFlexible(dateStr) {
        if (!dateStr) return null;
        const dt = new Date(dateStr);
        if (!isNaN(dt.getTime())) return dt;
        let cleaned = dateStr.replace(/(\d{1,2}:\d{2}:\d{2})\s+(AM|PM)/i, '$1$2');
        const fallback = new Date(cleaned);
        if (!isNaN(fallback.getTime())) return fallback;
        return null;
    }

    function formatUTCto12hr(isoString) {
        if (!isoString) return "—";
        const d = new Date(isoString);

        const datePart = isoString.slice(0, 10);

        let h = d.getUTCHours();
        const m = String(d.getUTCMinutes()).padStart(2, '0');
        const s = String(d.getUTCSeconds()).padStart(2, '0');

        const period = h < 12 ? 'AM' : 'PM';
        h = h % 12 || 12;

        const timePart = `${String(h).padStart(2, '0')}:${m}:${s} ${period}`;

        return `${datePart} ${timePart}`;
    }

    const dateJoinedTemplate = (rowData) => {
        return (
            <div>
                {formatUTCto12hr(rowData.date_joined)}
            </div>
        );
    };

    const handleToggleLockout = (userId) => {
        const url = `${toggleUserLockout}${userId}/toggle-lockout/`;
        axios.post(url, {}, {
            headers: { 'Content-Type': 'application/json' },
        })
            .then((response) => {
                if (response.status === 200) {
                    const { is_locked, locked_at, lock_reason } = response.data;
                    const updateRow = (rows) =>
                        rows.map(row => row.id === userId ? { ...row, is_locked, locked_at, lock_reason } : row);
                    setCustomers(prev => updateRow(prev));
                    setFullCustomersData(prev => updateRow(prev));
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: is_locked ? 'User locked out' : 'User lockout removed',
                        life: 3000,
                    });
                    getAllSoftwareUsers();
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            });
    };

    const lockoutBody = (rowData) => {
        const lockedAt = (() => {
            if (!rowData.locked_at) return null;
            const [datePart, timePart] = rowData.locked_at.split(/T| /);
            const [year, monthNum, day] = datePart?.split('-') ?? [];
            const [hour, minute] = timePart?.split(':') ?? [];
            if (!year || !hour) return rowData.locked_at;
            const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
            const month = months[parseInt(monthNum, 10) - 1];
            const h24 = parseInt(hour, 10);
            const ampm = h24 >= 12 ? 'pm' : 'am';
            const h12 = String(h24 % 12 || 12).padStart(2, '0');
            return `${month} ${day}, ${year} | ${h12}:${minute} ${ampm}`;
        })();
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                <ToggleButton
                    checked={rowData.is_locked}
                    onChange={() => handleToggleLockout(rowData.id)}
                    onLabel="Locked"
                    offLabel="Unlocked"
                    onIcon="pi pi-lock"
                    offIcon="pi pi-lock-open"
                    style={{
                        background: rowData.is_locked ? '#ef4444' : '#22c55e',
                        borderColor: rowData.is_locked ? '#ef4444' : '#22c55e',
                        color: '#fff',
                    }}
                />
                {rowData.is_locked && lockedAt && (
                    <span style={{ fontSize: '11px', color: '#9ca3af' }}>{lockedAt}</span>
                )}
            </div>
        );
    };
    

    const handleToggleKpiManaged = (userId) => {
        const url = `${toggleKpiManaged}${userId}/toggle-kpi-managed/`;
        axios.post(url, {}, { headers: { 'Content-Type': 'application/json' } })
            .then((response) => {
                if (response.status === 200) {
                    const { kpi_managed } = response.data;
                    const updateRow = (rows) =>
                        rows.map(row => row.id === userId ? { ...row, kpi_managed } : row);
                    setCustomers(prev => updateRow(prev));
                    setFullCustomersData(prev => updateRow(prev));
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: kpi_managed ? 'KPI tracking enabled' : 'KPI tracking disabled',
                        life: 3000,
                    });
                } else {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
                }
            })
            .catch(() => {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Something went wrong', life: 3000 });
            });
    };

    const kpiManagedBody = (rowData) => (
        <ToggleButton
            checked={rowData.kpi_managed}
            onChange={() => handleToggleKpiManaged(rowData.id)}
            onLabel="On"
            offLabel="Off"
            onIcon="pi pi-check"
            offIcon="pi pi-times"
            style={{
                background: rowData.kpi_managed ? '#22c55e' : '#6b7280',
                borderColor: rowData.kpi_managed ? '#22c55e' : '#6b7280',
                color: '#fff',
            }}
        />
    );

    const LOCK_REASON_LABELS = {
        low_activity: { label: 'Low Activity', color: '#ef4444' },
        failed_attempts: { label: 'Failed Attempts', color: '#f97316' },
        manual: { label: 'Manual', color: '#8b5cf6' },
    };

    const lockReasonBody = (rowData) => {
        if (!rowData.lock_reason) return <span style={{ color: '#9ca3af', display: 'block', textAlign: 'center' }}>_</span>;
        const meta = LOCK_REASON_LABELS[rowData.lock_reason] || { label: rowData.lock_reason, color: '#ef4444' };
        return (
            <Tag
                value={`Locked: ${meta.label}`}
                style={{ background: meta.color, color: '#fff', fontSize: '11px', padding: '3px 8px', borderRadius: '12px', whiteSpace: 'nowrap' }}
            />
        );
    };

    return (
        <div className="card">
            <Toast ref={toast} />

            <DataTable
                className="oba-datatable"
                ref={dt}
                value={customers}
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 50, 100]}
                paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                scrollable
                scrollHeight="65vh"
                header={header}
                filters={filters}
                loading={loading}
                onFilter={(e) => setFilters(e.filters)}
                dataKey="id"
                // stateStorage="session"
                // stateKey="dt-state-demo-local"
                emptyMessage="No users found."
                tableStyle={{ minWidth: '50rem' }}
                sortField="date_joined" sortOrder={-1}
            >
                <Column header="Name" field='full_name' body={(rowData, options) => (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ fontSize: '11px', color: '#7a7a84', flexShrink: 0 }}>#{options.rowIndex + 1}</span>
                        {userBodyTemplate(rowData, options)}
                    </div>
                )} sortable frozen style={{ minWidth: 180 }}></Column>
                <Column field="email" header="Email" sortable style={{ minWidth: '2rem' }}></Column>
                <Column field="username" header="User Name" sortable style={{ minWidth: '2rem' }}></Column>
                <Column field="user_type" header="User Role" sortable style={{ minWidth: '8rem' }}></Column>
                <Column
                    field="date_joined"
                    header="Date Joined"
                    body={dateJoinedTemplate}
                    sortable
                    style={{ minWidth: '10rem' }}
                    sortFunction={({ data, field, order }) => {
                        return data.sort((a, b) => {
                            const dateA = parseDateFlexible(a[field]);
                            const dateB = parseDateFlexible(b[field]);

                            if (!dateA && !dateB) return 0;
                            if (!dateA) return order === 1 ? 1 : -1;   // nulls at bottom for asc, top for desc
                            if (!dateB) return order === 1 ? -1 : 1;

                            return order * (dateA.getTime() - dateB.getTime());
                        });
                    }}
                />
                <Column field="location_count" header="Locations/Teams" sortable style={{ minWidth: '2rem' }}></Column>
                <Column header="Manage Locations/Teams" body={manageLocationView} style={{ minWidth: '2rem' }}></Column>
                <Column header="Manage Active Pipeline" body={activePipelineView} style={{ minWidth: '12rem' }}></Column>
                <Column header="Manage User Type" body={manageUserTypes} style={{ minWidth: '14rem' }}></Column>
                <Column field="designation" header="Designation" body={designationView} style={{ minWidth: '2rem' }}></Column>
                <Column header="Branch" body={branchView} style={{ minWidth: '2rem' }}></Column>
                <Column header="NMLS ID & QR Link" body={nmlsIdQRLinkView} style={{ minWidth: '12rem' }}></Column>
                <Column field="company" header="Company" body={companyView} style={{ minWidth: '2rem' }}></Column>
                <Column header="Language" body={languageView} style={{ minWidth: '2rem' }}></Column>
                <Column header="Profile Image" body={uploadBody} style={{ width: '15%' }}></Column>
                <Column header="Biz Card" body={bizCardUploadBody} style={{ width: '15%' }}></Column>
                <Column header="Update Password" body={updatePasswordBody} style={{ minWidth: '2rem' }}></Column>
                <Column header="Business Info" body={update360EmailPassword} style={{ minWidth: '12rem' }}></Column>
                {/* <Column header="Status" body={terminateBody} style={{ minWidth: '2rem' }}></Column> */}
                <Column header="Status" body={userStatusView} style={{ minWidth: '2rem' }}></Column>
                <Column header="Lockout" body={lockoutBody} style={{ minWidth: '9rem' }}></Column>
                <Column header="Lock Reason" body={lockReasonBody} style={{ minWidth: '10rem' }}></Column>
                <Column header="KPI Managed" body={kpiManagedBody} style={{ minWidth: '9rem' }}></Column>
                <Column body={deleteBody} style={{ minWidth: '2rem' }}></Column>
            </DataTable>

            <AppModal
                header="Manage Designation"
                visible={designationDialogVisible}
                panelStyle={{ width: '50vw' }}
                onHide={() => {
                    setDesignationDialogVisible(false);
                    setSelectedDesignationUser(null);
                    setSelectedDesignation(null);
                    setSelectedSubDesignation(null);
                }}
                footer={designationManageFooter}
            >
                <FlexComponent flexDirection="column" gap="1rem" alignItems="center">
                    <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                        <label htmlFor="designation">Designation *</label>
                        <Dropdown
                            id="designation"
                            value={selectedDesignation}
                            options={designationList.map(designation => ({
                                label: designation.title,
                                value: designation.id,
                            })) || []}
                            onChange={(e) => {
                                setSelectedDesignation(e.value);
                                setSelectedSubDesignation(null);
                            }}
                            placeholder="Select Designation"
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                        <label htmlFor="subDesignation">Sub-Designation</label>
                        <Dropdown
                            id="subDesignation"
                            value={selectedSubDesignation}
                            options={
                                selectedDesignation
                                    ? (designationList.find(d => d.id === selectedDesignation)?.subdesignations || []).map(sub => ({
                                        label: sub.title,
                                        value: sub.id,
                                    }))
                                    : []
                            }
                            onChange={(e) => setSelectedSubDesignation(e.value)}
                            placeholder="Select Sub-Designation"
                            style={{ width: '100%' }}
                            disabled={!selectedDesignation}
                        />
                    </div>
                </FlexComponent>
            </AppModal>

            <AppModal
                header="Manage Branch"
                visible={branchDialogVisible}
                panelStyle={{ width: '50vw' }}
                onHide={() => {
                    setBranchDialogVisible(false);
                    setSelectedBranchUser(null);
                    setSelectedBranch(null);
                    setSelectedCostCenter(null);
                }}
                footer={branchManageFooter}
            >
                <FlexComponent flexDirection="column" gap="1rem" alignItems="center">
                    <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                        <label htmlFor="branch">Branch *</label>
                        <Dropdown
                            id="branch"
                            value={selectedBranch}
                            options={branchesList.map(branch => ({
                                label: branch.name,
                                value: branch.id,
                            })) || []}
                            onChange={(e) => {
                                setSelectedBranch(e.value);
                                setSelectedCostCenter(null);
                            }}
                            placeholder="Select Branch"
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                        <label htmlFor="costCenter">Cost Center *</label>
                        <Dropdown
                            id="costCenter"
                            value={selectedCostCenter}
                            options={
                                selectedBranch
                                    ? (branchesList.find(b => b.id === selectedBranch)?.cost_centers || []).map(cc => ({
                                        label: cc.name,
                                        value: cc.id,
                                    }))
                                    : []
                            }
                            onChange={(e) => setSelectedCostCenter(e.value)}
                            placeholder="Select Cost Center"
                            style={{ width: '100%' }}
                            disabled={!selectedBranch}
                        />
                    </div>
                </FlexComponent>
            </AppModal>

            <AppModal
                header="Edit Flyer Data"
                visible={flyerDialogVisible}
                panelStyle={{ width: '50vw' }}
                onHide={() => {
                    setFlyerDialogVisible(false);
                    setSelectedFlyerUser(null);
                    setNmlsId('');
                    setQrLink('');
                }}
                footer={flyerManageFooter}
            >
                <FlexComponent flexDirection="column" gap="1rem" alignItems="center">
                    <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                        <label htmlFor="nmlsId">NMLS ID</label>
                        <InputText
                            id="nmlsId"
                            value={nmlsId}
                            onChange={(e) => setNmlsId(e.target.value)}
                            placeholder="Enter NMLS ID"
                            style={{ width: '100%' }}
                        />
                    </div>
                    <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                        <label htmlFor="qrLink">QR Link</label>
                        <InputText
                            id="qrLink"
                            value={qrLink}
                            onChange={(e) => setQrLink(e.target.value)}
                            placeholder="Enter QR Link"
                            style={{ width: '100%' }}
                        />
                    </div>
                </FlexComponent>
            </AppModal>

            <AppModal
                header={convertLeader ? "Add Atleast One Team" : "Manage Allowed Locations"}
                visible={locationVisible}
                panelStyle={{ width: '50vw' }}
                onHide={handleLocationOnHide}
                footer={locationManageFooter}
            >
                <div>
                    <div className='purchase-form-group'>
                        <div className="card flex justify-content-center">
                            <MultiSelect
                                value={allowedLocations}
                                onChange={(e) => setAllowedLocations(e.value)}
                                options={activeLocations}
                                optionLabel="name"
                                filter
                                placeholder={convertLeader ? "Add Team" : "Manage Locations"}
                                maxSelectedLabels={3}
                                className="w-full md:w-20rem language-multiselect"
                            />
                        </div>
                    </div>
                </div>
            </AppModal>

            <AppModal
                header={"Update the Active Pipeline"}
                visible={activePipelineVisible}
                panelStyle={{ width: '50vw', minHeight: "75vh" }}
                onHide={handleLocationOnHide}
                footer={manageActivePipelineFooter}
            >
                <div>
                    <div className='purchase-form-group'>
                        <label htmlFor="branch">Active Pipeline *</label>
                        <div className="card flex justify-content-center">
                            <Dropdown
                                id="location_id"
                                optionValue="location_id"
                                optionLabel="name"
                                value={selectedActivePipeline}
                                options={allowedLocations}
                                style={{ width: '100%' }}
                                onChange={(e) => {
                                    setSelectedActivePipeline(e.value)
                                    setSelectedApplicationPipeline("")
                                }}
                                placeholder="Select Active Pipeline"
                                filter
                            />
                        </div>
                        <label htmlFor="branch">Application Pipeline *</label>
                        <div className="card flex justify-content-center">
                            <Dropdown
                                id="value"
                                optionValue="value"
                                optionLabel="label"
                                value={selectedApplicationPipeline}
                                options={userOptions}
                                style={{ width: '100%' }}
                                onChange={(e) => setSelectedApplicationPipeline(e.value)}
                                placeholder="Select Application Pipeline"
                                filter
                            />
                        </div>

                        <label htmlFor="branch">Default Followers</label>
                        <div className="card flex justify-content-center">
                            <MultiSelect
                                id="value"
                                optionValue="value"
                                optionLabel="label"
                                value={selectedDefaultFollowers}
                                options={userOptions}
                                style={{ width: '100%' }}
                                onChange={(e) => setSelectedDefaultFollowers(e.value)}
                                placeholder="Select Followers"
                                filter
                            />
                        </div>
                    </div>
                </div>
            </AppModal>

            <AppModal
                header="Set New Password"
                visible={userVisible}
                panelStyle={{ width: '50vw' }}
                onHide={handlePasswordOnHide}
                footer={userManageFooter}
            >
                <div>
                    <div className='purchase-form-group'>
                        <form className='user-form'>
                            <div className="flex justify-content-center">
                                <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                                    <label htmlFor="password">New Password *</label>
                                    <span className="p-input-icon-right full-input">
                                        <i className={`pi ${passwordVisible ? 'pi-eye' : 'pi-eye-slash'} password-icon`} onClick={handlePasswordVisible} />
                                        <InputText
                                            value={password}
                                            type={`${passwordVisible ? 'text' : 'password'}`}
                                            className='full-input'
                                            id="password"
                                            aria-describedby="password-help"
                                            onChange={(e) => setPassword(e.target.value)}
                                        />
                                    </span>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </AppModal>

            <AppModal
                header="Business Info"
                visible={emailPassword360Visible}
                panelStyle={{ width: '50vw' }}
                onHide={handleEmailPassword360OnHide}
                footer={emailPassword360Footer}
            >
                <div>
                    <FlexComponent gap="1rem" className='profileContainer'>
                        <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                            <label htmlFor="officeTitle">Title </label>
                            <span className="p-input-icon-right full-input">
                                <InputText
                                    value={officeTitle}
                                    className='full-input'
                                    id="officeTitle"
                                    onChange={(e) => setOfficeTitle(e.target.value)}
                                />
                            </span>
                        </div>
                        <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                            <label htmlFor="email360">Email </label>
                            <span className="p-input-icon-right full-input">
                                <InputText
                                    value={email360}
                                    className='full-input'
                                    id="email360"
                                    onChange={(e) => setEmail360(e.target.value)}
                                />
                            </span>
                        </div>
                        <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                            <label htmlFor="businessPhone">Business Phone </label>
                            <span className="p-input-icon-right full-input">
                                <InputText
                                    value={businessPhone}
                                    className='full-input'
                                    id="businessPhone"
                                    onChange={(e) => setBusinessPhone(e.target.value)}
                                />
                            </span>
                        </div>
                    </FlexComponent>
                </div>
            </AppModal>

            <AppModal
                header="Edit Name"
                visible={nameDialogVisible}
                panelStyle={{ width: '30vw' }}
                onHide={handleNameOnHide}
                footer={nameManageFooter}
            >
                <div className='purchase-form-group'>
                    <div className="flex flex-column gap-3" style={{ width: '100%' }}>
                        <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                            <label htmlFor="editFirstName">First Name *</label>
                            <InputText
                                id="editFirstName"
                                value={editFirstName}
                                className='full-input'
                                onChange={(e) => setEditFirstName(e.target.value)}
                            />
                        </div>
                        <div className="flex flex-column gap-2 lable-input-group" style={{ width: '100%' }}>
                            <label htmlFor="editLastName">Last Name</label>
                            <InputText
                                id="editLastName"
                                value={editLastName}
                                className='full-input'
                                onChange={(e) => setEditLastName(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </AppModal>
        </div>
    );
}